import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { AppConstants } from '../../../../app.constants';
import { FilesService } from '../../../../core/services/http-services/files.service';
import { PlaylistItemDTO } from '../../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { ModalTwoFactorAuthenticationComponent } from '../modal-two-factor-authentication/modal-two-factor-authentication.component';
import { LoaderModule } from '../../../../core/elements/loader/loader.module';

@Component({
  selector: 'video-preview',
  standalone: true,
  imports: [
    MatIconModule,
    MatTooltipModule,
    LoaderModule
  ],
  templateUrl: './video-preview.component.html',
  styleUrl: './video-preview.component.scss'
})
export class VideoPreviewComponent implements OnInit, OnDestroy {
  @Input() item: PlaylistItemDTO;
  isVideoPreview: boolean;
  appConst = AppConstants;

  constructor(
    public readonly dialogRef: MatDialogRef<ModalTwoFactorAuthenticationComponent>,
    private readonly filesService: FilesService
  ) {}

  ngOnInit(): void {
    if (this.isVideoPreview && !this.item.PlaylistItemLinks[0].videoContent) {
      this.filesService.previewContent(this.item, null, true);
    }
  }

  ngOnDestroy(): void {
    this.filesService.downloadPreviewRequest?.unsubscribe();
  }
}
